/* eslint-disable import/no-unresolved */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, IconButton } from '@material-ui/core';
import CallIcon from '@mui/icons-material/Call';
import Avatar from '@material-ui/core/Avatar';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import firebase from "../../config/firebase/index";


import style from './style';
import encSecret from '../../config/encryption';
var CryptoJS = require("crypto-js");


function ButtonAtom(props) {
    const classes = style();
    const dealId = props.dealId;
    const [customers, setCustomers] = useState([]);
    let phoneLink = "";
    let whatsappLink = "";

    useEffect(() => {
        currentDeal();

    }, []);

    const currentDeal = () => {

        firebase.database().ref("Customer").orderByChild("DealId")
            .equalTo(dealId).once("value", snapshot => {

                const customerData = snapshot.val();
                // const user = userData;

                const customers = [];
                for (const key in customerData) {

                    const quoteObj = {
                        id: key,
                        ...customerData[key],
                    };
                    if (quoteObj.method === "whatsapp") {
                        customers.push(quoteObj);
                    }
                }
                setCustomers(customers);
                console.log(customers);
                phoneLink = "tel:" + customers.PhoneNo;
                whatsappLink = "https://wa.me/91" + customers.PhoneNo;


            })
    }

    const formatDate = (DATE) => {
        let d = DATE.split(" ");
        let dd = d[0].split("-");
        let newDATE = dd[1] + "/" + dd[2] + "/" + dd[0] + " " + d[1];
        console.log("NDATE ::: ", newDATE);
        let nDate = new Date(newDATE);

        console.log("::: :", nDate);
        let dateArr = nDate.toString().split(" ");
        let hrs = nDate.getHours();
        let mnts = nDate.getMinutes();
        let AMPM = hrs >= 12 ? 'PM' : 'AM';
        hrs = hrs % 12;
        hrs = hrs ? hrs : 12;
        mnts = mnts < 10 ? '0' + mnts : mnts;
        var result = dateArr[2] + " " + dateArr[1] + " " + hrs + ':' + mnts + ' ' + AMPM;
        return result;
        // return nDate.toLocaleString('en-IN', { day: 'numeric', month: 'short', hour: 'numeric', minute: 'numeric', hour12: true })
    }

    return (
        <Grid className={classes.contactListSection}>
            {customers && customers.map((customer, index) => (
                <Grid key={index} className={classes.contentBox}>
                    <Box className={`${classes.oneByOne}`} p={1} pt={2}>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <Box>
                                <WhatsAppIcon />
                            </Box>
                            <Box ml={1} mr={1}>
                                <Avatar sx={{ width: '130px', height: '130px', }} className={classes.image} alt="farmer" src={customer.img} />
                            </Box>
                            <Box>
                                <Typography variant="caption">
                                    <div style={{ fontSize: 14, fontWeight: 600 }}>
                                        {customer.Name == "Unknown" ? customer.Name : CryptoJS.AES.decrypt(customer.Name, encSecret.key).toString(CryptoJS.enc.Utf8)}
                                    </div>
                                    <div style={{ marginTop: "-5px" }}>
                                        {formatDate(customer.time)}
                                    </div>
                                </Typography>
                            </Box>

                            <Box className={classes.mlAuto}>
                                <a href={"tel:" + customer.PhoneNo}>

                                    <CallIcon />
                                </a>
                                <a href={"https://wa.me/91" + customer.PhoneNo}>

                                    <WhatsAppIcon />
                                </a>
                            </Box>
                        </div>


                    </Box>
                </Grid>
            )).reverse()}
        </Grid>
    );
}



export default ButtonAtom;